'use strict';

export const configAngularDomain = [
  '$domainProvider',
  'ROOT_API_COLLECTION',
  'ROOT_API_SPEC',
  function ($domainProvider, ROOT_API_COLLECTION, ROOT_API_SPEC) {
    $domainProvider.setUserSyncClosure(['AuthService', function (AuthService) {
      return AuthService.getCurrentUserSync();
    }]);

    $domainProvider.setUserIdClosure(['AuthService', function (AuthService) {
      return AuthService.getUserIdOnAuth();
    }]);

    $domainProvider.setUserDomainName('UserDomain');

    $domainProvider.setDeleteHandler([
      '$link',
      'AuthService',
      'FirebaseQueueService',
      function ($link, AuthService, FirebaseQueueService) {
        return AuthService.getUserIdOnAuth().then(function (userId) {
          return FirebaseQueueService.addTask({
            method: 'delete',
            id: $link.id,
            collection: $link.collection,
          }, userId, ROOT_API_COLLECTION, ROOT_API_SPEC);
        });
      }]);

    // former delete handler, for reference
    // $domainProvider.setDeleteHandler([
    //   '$link',
    //   'AuthService',
    //   'FirebaseMqService',
    //   function ($link, AuthService, FirebaseMqService) {
    //     return AuthService.getUserIdOnAuth().then(function (userId) {
    //       return FirebaseMqService.submitRequest({
    //         user: userId,
    //         method: 'delete',
    //         id: $link.id,
    //         collection: $link.collection
    //       }, 'firebase-domain-updates-requests', 'firebase-domain-updates-responses');
    //     });
    //   }]);
  }];



// WEBPACK FOOTER //
// ./src/js/config/configAngularDomain.js